module.exports = __webpack_public_path__ + "static/media/cricket.47b3e92e.svg";